module.exports = __webpack_public_path__ + "img/joinUs_content2.2e777f55.png";